import React, { useEffect, useState } from 'react'
import { Row, Col, Button, Avatar, Modal, message } from 'antd'
import { getProfile, gethistory, getPerformance, getVideo } from 'store/auth/profile/profileSlice'
import { useSelector, useDispatch } from 'react-redux'
import player from '../../assets/images/player.jpeg'
import { useNavigate } from 'react-router-dom'
import MultiStepForm from 'components/multiStepForm'
import { ProgressBar } from 'components/ProgressBar'
import { BASE_URL } from 'helpers/api_helper'
import { UserOutlined } from '@ant-design/icons';

// import { useRef } from 'react'

export const Header1 = ({ gapp }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const profil = useSelector((state) => state.Profile.profile)
  // const history = useSelector((state) => state.Profile.history)
  // const video = useSelector((state) => state.Profile.videos)
  // const performance = useSelector((state) => state.Profile.performance)
  const [showForm, setShowForm] = useState(false)
  // const [addPercentage, setaddPercentage] = useState(0)

  // Utiliser des références pour suivre ce qui a été calculé
  // const hasAddedPerformance = useRef(false)
  // const hasAddedHistory = useRef(false)

  // Premier useEffect pour récupérer le profil
  useEffect(() => {
    dispatch(getProfile())
  }, [dispatch])
  useEffect(() => {
    const fetchAll = async () => {
      try {
        await dispatch(getPerformance());
        await dispatch(getVideo());
        const id = profil?._id;
        console.log(id);
        if (id) {
          await dispatch(gethistory(id));
        }

      } catch (err) {
        console.error(err);
        message.error("Erreur lors du chargement des données.");
      }
    };

    fetchAll();
  }, [dispatch, profil]);

  const [playerPhoto, setPlayerPhoto] = useState(null);
  useEffect(() => {
    setPlayerPhoto(null);
    if (profil?.photo) {
      const cleanApiUrl = BASE_URL.replace(/\/+$/, '');

      let cleanLogo = profil?.photo.replace(/\\/g, '/').replace(/^\/+/, '');

      if (!cleanLogo.startsWith('uploads/')) {
        cleanLogo = 'uploads/' + cleanLogo;
      }
      setPlayerPhoto(`${cleanApiUrl}/${cleanLogo}`);
    }
  }, [profil])
  // Deuxième useEffect qui s'exécute quand profil est disponible
  // useEffect(() => {
  //   if (profil && profil._id) {
  //     console.log('Profil ID disponible:', profil._id)
  //     dispatch(gethistory(profil._id))
  //     dispatch(getPerformance())
  //   }
  // }, [profil, dispatch])

  // Gestion de la performance
  // useEffect(() => {
  //   if (performance.length>0 && !hasAddedPerformance.current) {
  //     console.log('performance added')
  //     setaddPercentage(prev => prev + 20)
  //     hasAddedPerformance.current = true
  //   }
  // }, [performance])

  // // Gestion de l'historique - séparé pour éviter les calculs redondants
  // useEffect(() => {
  //   if (history && history.length > 0 && !hasAddedHistory.current) {
  //     console.log('history added')
  //     setaddPercentage(prev => prev + 20)
  //     hasAddedHistory.current = true
  //   }
  // }, [history])
  // useEffect(()=>{
  //   let newPercentage = 0
  //   if (performance.length > 0) newPercentage += 20
  //   if (video.length > 0) newPercentage += 10
  //   if (history.length > 0) newPercentage += 20    
  //   setaddPercentage(newPercentage)
  // },
  //   [performance])


  return (
    <>
      <div style={{ backgroundColor: "#F3F8F9", padding: "30px", height: gapp == 'accueille' ? '400px' : null }}
        className='d-flex justify-content-center'>
        <Row style={{ display: "flex", justifyContent: "center", gap: gapp == 'accueille' ? "10px" : "100px" }}>
          <Col style={{ display: "flex", alignItems: 'center', gap: "40px" }}>

            {playerPhoto ?
              <Avatar className='avatar-lg'
                //  src={`http://localhost:5001/${profil.photo?.replace(/\\/g, '/')}`} />
                src={playerPhoto} />
              :
              <UserOutlined style={{ fontSize: 45 }} />
            }
            <div>
              {
                gapp == 'accueille' ? (
                  <h4 className="black-title"> {profil.firstName} , {profil.lastName}</h4>

                ) : (
                  <h1 className="black-title"> {profil.firstName} , {profil.lastName}</h1>

                )
              }
              <p className='fs-4'>{profil?.age && profil?.age + " ans"} </p>
              <Button className='custom-bg mb-2'
                onClick={() => navigate('/profile')}
              > Modifier le profil
              </Button>
            </div>
          </Col>
          <Col >
            <ProgressBar horizantal='horisantal' />
            <Button
              onClick={() => setShowForm(true)}
              style={{ color: 'green' }} > Completer</Button>
          </Col>
        </Row>
      </div>
      {showForm ? (

        <Modal
          open={showForm}
          onCancel={() => setShowForm(false)}
          width={800}
          bodyStyle={{ minHeight: "500px", overflowY: "auto" }} // Set height & enable scrolling
          footer={null}
        >
          <MultiStepForm />
        </Modal>
      ) : null}

    </>
  )
}
